import { Button } from "antd";
import React from "react";
import { FaTimes } from "react-icons/fa";
import { ButtonSpinner } from "../../components/spinners";
import { useLocation } from "react-router-dom";

const DeleteAbsenceModal = ({ setVisibleDelete, data, handle }) => {
  const closeModal = () => {
    setVisibleDelete(false);
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <div className="text-right">
          <button className="close-modal" onClick={closeModal}>
            <FaTimes />
          </button>
        </div>

        <div className="modal-body mt-3">
          <h2 className="text-xl font-bold">
            {data?.selectedData?.type == "payroll"
              ? "Are you sure want to delete this payroll category"
              : "Are you sure want to delete this Absence Data"}
            ?
          </h2>

          <form className="mt-4">
            <div className="item mt-8">
              <table>
                <tbody>
                  <tr>
                    <td className="font-bold">Name</td>
                    <td className="pl-5">{data?.selectedData?.name}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="item mt-8 text-center">
              <Button
                className="btn btn-blue w-1/5 bg-blue-disable"
                onClick={() => handle?.delete(data?.selectedData?.type)}
                disabled={data?.isLoading}
              >
                {data?.isLoading ? <ButtonSpinner /> : "Delete"}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DeleteAbsenceModal;
